var LogisticOrderModule = /** @class */ (function () {
    function LogisticOrderModule() {
    }
    return LogisticOrderModule;
}());
export { LogisticOrderModule };
